/** Organization ID for the Impact Report */
export const ORGID = "365"; //360 for production, this is for testing
export * from "./cleaner";
export * from "./connector";
export * from "./types";
export * from "./processedTypes";
export { convertImpacts } from "./impacts";
export { descriptionMap } from "./impacts";
